import * as React from 'react'

/**
 * @description GraphicDesign icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { GraphicDesign } from '@sravni/design-system-icons'
 *
 * <GraphicDesign />
 * ```
 */
export const GraphicDesign = React.forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>((props, ref) => (
  <svg ref={ref} data-qa="GraphicDesign" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M1.563 9.56c10.312-6.123 9.27 3.773 16.875.44"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.115 2.5c5.822 2.813 3.947 12.188 1.135 15M10.938 2.5C16.76 5.313 15 15 12.812 17.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.563 15.658c9.27-6.491 11.25 1.842 11.25 1.842"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.563 17.5H3.438a1.875 1.875 0 0 1-1.876-1.875V4.375c0-1.036.84-1.875 1.875-1.875h13.126c1.035 0 1.875.84 1.875 1.875v11.25c0 1.036-.84 1.875-1.875 1.875Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
))
